
export abstract class AxInit {
    abstract AxInit(init?: any): void;

}

export function ModuleName(aliasName: string)  {
    const orgName = aliasName;
    return function (target: Function) {
        target.prototype.moduleAliasName = orgName;
    }
}